export const ASSESSMENT_LOAD = 'ASSESSMENT_LOAD';
export const ASSESSMENT_LOAD_SUCCESS = 'ASSESSMENT_LOAD_SUCCESS';
export const ASSESSMENT_LOAD_FAIL = 'ASSESSMENT_LOAD_FAIL';

export const ASSESSMENT_SUBMIT_ANSWER = 'ASSESSMENT_SUBMIT_ANSWER';
export const ASSESSMENT_SUBMIT_ANSWER_SUCCESS = 'ASSESSMENT_SUBMIT_ANSWER_SUCCESS';
export const ASSESSMENT_SUBMIT_ANSWER_FAIL = 'ASSESSMENT_SUBMIT_ANSWER_FAIL';

export const ASSESSMENT_GET_RESULT = 'ASSESSMENT_GET_RESULT';
export const ASSESSMENT_GET_RESULT_SUCCESS = 'ASSESSMENT_GET_RESULT_SUCCESS';
export const ASSESSMENT_GET_RESULT_FAIL = 'ASSESSMENT_GET_RESULT_FAIL';

export const ASSESSMENT_RESET = 'ASSESSMENT_RESET';
export const ASSESSMENT_RESET_SUCCESS = 'ASSESSMENT_RESET_SUCCESS';
export const ASSESSMENT_RESET_FAIL = 'ASSESSMENT_RESET_FAIL';

export const ASSESSMENT_SET_PHASE = 'ASSESSMENT_SET_PHASE';
export const ASSESSMENT_SET_QUESTION = 'ASSESSMENT_SET_QUESTION';
export const ASSESSMENT_NEXT_QUESTION = 'ASSESSMENT_NEXT_QUESTION';

export const ASSESSMENT_VALIDATE_CODE = 'ASSESSMENT_VALIDATE_CODE';
export const ASSESSMENT_VALIDATE_CODE_SUCCESS = 'ASSESSMENT_VALIDATE_CODE_SUCCESS';
export const ASSESSMENT_VALIDATE_CODE_FAIL = 'ASSESSMENT_VALIDATE_CODE_FAIL';

export const ASSESSMENT_PATCH_SESSION = 'ASSESSMENT_PATCH_SESSION';
export const ASSESSMENT_PATCH_SESSION_SUCCESS = 'ASSESSMENT_PATCH_SESSION_SUCCESS';
export const ASSESSMENT_PATCH_SESSION_FAIL = 'ASSESSMENT_PATCH_SESSION_FAIL';

export const ASSESSMENT_LINK_USER = 'ASSESSMENT_LINK_USER';
export const ASSESSMENT_LINK_USER_SUCCESS = 'ASSESSMENT_LINK_USER_SUCCESS';
export const ASSESSMENT_LINK_USER_FAIL = 'ASSESSMENT_LINK_USER_FAIL';

export const ASSESSMENT_GET_ME = 'ASSESSMENT_GET_ME';
export const ASSESSMENT_GET_ME_SUCCESS = 'ASSESSMENT_GET_ME_SUCCESS';
export const ASSESSMENT_GET_ME_FAIL = 'ASSESSMENT_GET_ME_FAIL';

export const ASSESSMENT_EMAIL_RESULTS = 'ASSESSMENT_EMAIL_RESULTS';
export const ASSESSMENT_EMAIL_RESULTS_SUCCESS = 'ASSESSMENT_EMAIL_RESULTS_SUCCESS';
export const ASSESSMENT_EMAIL_RESULTS_FAIL = 'ASSESSMENT_EMAIL_RESULTS_FAIL';

export const ASSESSMENT_EMAIL_RESUME_LINK = 'ASSESSMENT_EMAIL_RESUME_LINK';
export const ASSESSMENT_EMAIL_RESUME_LINK_SUCCESS = 'ASSESSMENT_EMAIL_RESUME_LINK_SUCCESS';
export const ASSESSMENT_EMAIL_RESUME_LINK_FAIL = 'ASSESSMENT_EMAIL_RESUME_LINK_FAIL';

export const ASSESSMENT_WONDERLIC_START = 'ASSESSMENT_WONDERLIC_START';
export const ASSESSMENT_WONDERLIC_START_SUCCESS = 'ASSESSMENT_WONDERLIC_START_SUCCESS';
export const ASSESSMENT_WONDERLIC_START_FAIL = 'ASSESSMENT_WONDERLIC_START_FAIL';
